import axios from 'axios'
import api from '@/api'

const reservationList = {
  state: {
    data: []
  },
  getters: {
    getReservationList: state => state.data
  },
  mutations: {
    RESERVATION_LIST_GET (state, payload) {
      state.data = payload
    },
  },
  actions: {
    reservationListGet (context) {
      axios({
        method: 'POST',
        url: `${api}/patients/reservation-list/get-fields`,
      }).then(response => {
        context.commit('RESERVATION_LIST_GET', response.data);
      }).catch((error) => {
        console.log(error);
      })
    }
  }
};
export default reservationList
